(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["issada-bundle-and-save"] && !Shopify.designMode) return;
  try {
    
/* ISSADA Bundle and Save. Existing Vitals offers remain the discount authority.
 * Integration verified against Vitals storefront build 85849, 15 October 2026:
 * bundles: _oid = offerId_randomClaim; BOGO rewards append _bogoBonusItem.
 * Volume add-ons use Vitals' _vd* claim fields and _vdAddonItem identifier.
 * Every submission is checked against the returned Shopify cart. Failed offers
 * are removed by their unique private claim, preserving other cart contents.
 */
(() => {
  'use strict';
  if (window.IssadaBundleSave) { window.IssadaBundleSave.init(); return; }
  const sections = new WeakMap();
  const root = () => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const clean = value => String(value || '').trim().toLocaleLowerCase();
  const list = value => String(value || '').split(',').map(clean).filter(Boolean);
  const uid = () => (window.crypto?.randomUUID?.() || `${Date.now()}${Math.random().toString(36).slice(2)}`).replace(/[^a-z0-9]/gi, '').slice(0, 10);
  const currency = () => window.Shopify?.currency?.active || document.documentElement.dataset.currency || 'AUD';
  const rate = () => Number(window.Shopify?.currency?.rate) || 1;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-AU', { style: 'currency', currency: currency() }).format(cents / 100);

  function expiry(value) {
    if (!value) return Infinity;
    const raw = String(value).trim().replace(' ', 'T');
    const local = /T\d\d:\d\d$/.test(raw) ? `${raw}:00` : raw;
    const timestamp = Date.parse(/[zZ]$|[+-]\d\d:\d\d$/.test(raw) ? raw : `${local}+10:00`);
    return Number.isFinite(timestamp) ? timestamp : NaN;
  }

  async function request(path, body) {
    const response = await fetch(`${root()}${path}`, {
      method: body === undefined ? 'GET' : 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      ...(body === undefined ? {} : { body: JSON.stringify(body) })
    });
    let data;
    try { data = await response.json(); }
    catch (_) { throw new Error('The cart could not be read. Please try again.'); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'This offer could not be added. Please check your selections.');
    return data;
  }

  function usableProducts(products, excluded) {
    return (products || []).map(product => ({
      ...product,
      hasVariantChoice: (product.variants || []).length > 1,
      variants: (product.variants || []).filter(variant => variant.available && !excluded.includes(clean(variant.title)))
    })).filter(product => product.id && product.variants.length);
  }

  function selectField(parent, label, options, selected, onChange, id) {
    const wrapper = document.createElement('label');
    wrapper.className = 'ibs__field';
    const caption = document.createElement('span');
    caption.className = 'ibs__field-label';
    caption.textContent = label;
    const select = document.createElement('select');
    select.className = 'ibs__select';
    select.id = id;
    select.setAttribute('aria-label', label);
    for (const option of options) select.add(new Option(option.label, String(option.value)));
    select.value = String(selected ?? '');
    select.addEventListener('change', () => onChange(select.value));
    wrapper.append(caption, select);
    parent.append(wrapper);
    return select;
  }

  function makeItems(state, claim) {
    const { data, selected, quantity, addonChecked } = state;
    const offerId = Number(data.offerId);
    if (!Number.isSafeInteger(offerId) || offerId <= 0) throw new Error('This offer is temporarily unavailable.');
    const oid = `${offerId}_${claim}`;
    const privateProperties = { _issada_bundle_save: claim };
    const items = selected.map((selection, index) => {
      if (!selection?.variant) throw new Error('Please choose each product and shade.');
      const item = { id: Number(selection.variant.id), quantity: 1, properties: { ...privateProperties } };
      if (data.kind !== 'volume') item.properties._oid = oid + (data.kind === 'bogo' && index > 0 ? '_bogoBonusItem' : '');
      return item;
    });

    if (data.kind === 'volume' && addonChecked) {
      const addon = state.pools[1][0];
      const variant = addon?.variants[0];
      if (!variant) throw new Error('The optional add-on is out of stock.');
      // Same claim structure used by Vitals' Volume Discount add-on widget.
      const signature = `o:${offerId}|t:${quantity}|g:0:addon:0:${variant.id}:1`;
      const fields = { _vdOfferId: String(offerId), _vdTierQty: String(quantity), _vdClaimSig: signature };
      for (const item of items) Object.assign(item.properties, fields);
      items.push({
        id: Number(variant.id), quantity: 1,
        properties: { ...privateProperties, ...fields, _vdGiftUnitQty: '1', _oid: `${offerId}_t${quantity}a0v${variant.id}_vdAddonItem` }
      });
    }

    // Preserve the main-product/extra grouping used by the current Vitals widget.
    const parent = items[0];
    for (let index = 1; index < items.length; index++) {
      // Product bundles stay flat: a collection can contain an existing Shopify
      // component bundle, which Shopify does not allow to be nested again.
      const isExtra = data.kind === 'bogo' || items[index].properties._oid?.endsWith('_vdAddonItem');
      if (items[index].id !== parent.id && isExtra) items[index].parent_id = parent.id;
    }
    // Identical variants within a bundle must form one cart line, with quantity
    // added together. A variant cannot be a child of itself.
    const combined = new Map();
    for (const item of items) {
      const key = `${item.id}:${JSON.stringify(item.properties)}:${item.parent_id || ''}`;
      if (combined.has(key)) combined.get(key).quantity += item.quantity;
      else combined.set(key, item);
    }
    return [...combined.values()];
  }

  function checkCart(state, cart, claim, requested) {
    const owned = cart.items.filter(item => item.properties?._issada_bundle_save === claim);
    const expected = new Map();
    for (const item of requested) expected.set(item.id, (expected.get(item.id) || 0) + item.quantity);
    const actual = new Map();
    for (const item of owned) actual.set(item.variant_id, (actual.get(item.variant_id) || 0) + item.quantity);
    if ([...expected].some(([id, count]) => actual.get(id) !== count)) return false;
    const discounted = item => item.final_line_price < item.original_line_price;
    const { data } = state;
    if (data.kind === 'bogo') {
      const rewards = owned.filter(item => item.properties?._oid?.endsWith('_bogoBonusItem'));
      if (!rewards.length) return false;
      if (data.discountType === 'percent' && Number(data.discountValue) === 100) return rewards.every(item => item.final_line_price === 0);
      if (data.discountType === 'fixed_price') {
        const conversion = cart.currency === 'AUD' ? 1 : rate();
        return rewards.every(item => item.final_price <= Math.round(Number(data.discountValue) * 100 * conversion) + (cart.currency === 'AUD' ? 0 : 1));
      }
      if (data.discountType === 'percent') return rewards.every(item => item.final_line_price <= Math.round(item.original_line_price * (1 - Number(data.discountValue) / 100)) + item.quantity);
      return rewards.every(discounted);
    }
    if (data.kind === 'volume') {
      const mains = owned.filter(item => !item.properties?._oid?.endsWith('_vdAddonItem'));
      const percent = state.tiers.find(tier => tier.quantity === state.quantity)?.percent;
      if (percent === undefined) return false;
      const original = mains.reduce((sum, item) => sum + item.original_line_price, 0);
      const final = mains.reduce((sum, item) => sum + item.final_line_price, 0);
      const units = mains.reduce((sum, item) => sum + item.quantity, 0);
      if (final > Math.round(original * (1 - percent / 100)) + units) return false;
      if (state.addonChecked) {
        const addons = owned.filter(item => item.properties?._oid?.endsWith('_vdAddonItem'));
        if (!addons.length) return false;
        const conversion = cart.currency === 'AUD' ? 1 : rate();
        return addons.every(item => item.final_price <= Math.round(Number(data.addonPrice) * 100 * conversion) + (cart.currency === 'AUD' ? 0 : 1));
      }
      return true;
    }
    const original = owned.reduce((sum, item) => sum + item.original_line_price, 0);
    const final = owned.reduce((sum, item) => sum + item.final_line_price, 0);
    const units = owned.reduce((sum, item) => sum + item.quantity, 0);
    if (data.discountType === 'percent') return final <= Math.round(original * (1 - Number(data.discountValue) / 100)) + units;
    if (data.discountType === 'fixed') {
      const conversion = cart.currency === 'AUD' ? 1 : rate();
      return original - final >= Math.round(Number(data.discountValue) * 100 * conversion) - units;
    }
    return false;
  }

  async function removeClaim(claim) {
    const cart = await request('cart.js');
    const updates = {};
    for (const item of cart.items) if (item.properties?._issada_bundle_save === claim) updates[item.key] = 0;
    if (!Object.keys(updates).length) return;
    const changed = await request('cart/update.js', { updates });
    if (changed.items.some(item => item.properties?._issada_bundle_save === claim)) throw new Error('Cart removal incomplete');
  }

  function notifyCart(section, response, cart, button) {
    document.dispatchEvent(new CustomEvent('issada:bundle-added', { detail: { cart, items: response.items || [] } }));
    const behavior = section.dataset.afterAdd;
    if (behavior === 'cart') { window.location.assign(`${root()}cart`); return; }
    if (behavior === 'drawer' && document.getElementById('CartDrawer') && window.theme) {
      // These events are supported by the store's current Impulse CartForm and
      // CartDrawer, without impersonating a product-form submission event.
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      return;
    }
    if (behavior === 'drawer') { window.location.assign(`${root()}cart`); return; }
    document.dispatchEvent(new CustomEvent('cart:build'));
    const notice = section.querySelector('[data-section-notice]');
    notice.replaceChildren();
    const link = document.createElement('a');
    link.className = 'ibs__cart-link';
    link.href = `${root()}cart`;
    link.textContent = 'View cart';
    notice.append('Offer added. ', link);
  }

  function setStatus(state, text, error = false) {
    state.status.textContent = text;
    state.status.dataset.error = String(error);
  }

  function updateImages(state) {
    const images = state.element.querySelector('[data-product-images]');
    if (!images) return;
    const products = state.selected.map(item => item.product).filter(Boolean);
    if (state.data.kind === 'volume' && state.addonChecked && state.pools[1][0]) products.push(state.pools[1][0]);
    const unique = [...new Map(products.map(product => [product.id, product])).values()].slice(0, 3);
    images.replaceChildren();
    for (const product of unique) {
      if (!product.image) continue;
      const image = document.createElement('img');
      image.src = product.image;
      image.alt = product.title;
      image.loading = 'lazy';
      image.width = 480;
      image.height = 480;
      images.append(image);
    }
  }

  function updateReady(state) {
    const complete = state.selected.length > 0 && state.selected.every(item => item?.variant);
    state.button.disabled = state.busy || !complete || state.unavailable || state.editor;
    if (!state.busy && !state.unavailable && !state.editor) {
      if (complete) setStatus(state, '');
      else setStatus(state, 'Choose your shades to continue.');
    }
    updateImages(state);
  }

  function productChoice(state, parent, slot, pool) {
    const label = state.data.kind === 'bogo' && slot > 0 ? 'Receive' : `Product ${slot + 1}`;
    const previous = state.selected[slot];
    const defaultIndex = state.data.kind.startsWith('bundle_') && pool === state.pools[0] ? Math.min(slot, pool.length - 1) : 0;
    const product = pool.find(item => item.id === previous?.product?.id) || pool[defaultIndex];
    if (!product) { state.unavailable = true; return; }
    const selection = { product, variant: null };
    state.selected[slot] = selection;
    const variantContainer = document.createElement('div');
    const chooseVariant = (next, preserve) => {
      selection.product = next;
      variantContainer.replaceChildren();
      const hasShades = next.hasVariantChoice;
      const previousVariant = preserve && next.variants.find(item => item.id === previous?.variant?.id);
      selection.variant = previousVariant || (!hasShades ? next.variants[0] : null);
      if (hasShades) selectField(variantContainer, `${label} — shade`, [
        { value: '', label: 'Choose shade' },
        ...next.variants.map(variant => ({ value: variant.id, label: variant.title }))
      ], selection.variant?.id || '', value => {
        selection.variant = next.variants.find(variant => String(variant.id) === value) || null;
        updateReady(state);
      }, `ibs-${state.data.key}-${slot}-shade`);
      updateReady(state);
    };
    if (pool.length > 1) selectField(parent, label, pool.map(item => ({ value: item.id, label: item.title })), product.id, value => {
      const next = pool.find(item => String(item.id) === value);
      if (next) chooseVariant(next, false);
    }, `ibs-${state.data.key}-${slot}-product`);
    else if (state.data.kind.startsWith('bundle_')) {
      const caption = document.createElement('span');
      caption.className = 'ibs__field-label';
      caption.textContent = product.title;
      parent.append(caption);
    }
    parent.append(variantContainer);
    chooseVariant(product, true);
  }

  function renderChoices(state) {
    state.choices.replaceChildren();
    const count = state.data.kind === 'bundle_3' ? 3 : state.data.kind === 'volume' ? state.quantity : 2;
    state.selected.length = count;
    state.unavailable = false;
    if (state.data.kind === 'volume') {
      selectField(state.choices, 'Quantity', state.quantities.map(value => ({ value, label: `${value} ${value === 1 ? 'item' : 'items'}` })), state.quantity, value => {
        state.quantity = Number(value);
        state.addonChecked = state.quantity >= Number(state.data.addonFromQuantity) && state.pools[1].length > 0;
        renderChoices(state);
      }, `ibs-${state.data.key}-quantity`);
    }
    for (let slot = 0; slot < count; slot++) {
      const pool = state.data.kind === 'volume' ? state.pools[0] : state.pools[slot];
      productChoice(state, state.choices, slot, pool);
    }
    if (state.data.kind === 'volume' && state.pools[1].length) {
      const addon = state.pools[1][0];
      const label = document.createElement('label');
      label.className = 'ibs__addon';
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.checked = state.addonChecked;
      checkbox.addEventListener('change', () => { state.addonChecked = checkbox.checked; updateImages(state); });
      const copy = document.createElement('span');
      copy.textContent = `Add ${addon.title} — ${money(Number(state.data.addonPrice) * 100 * rate())}`;
      label.append(checkbox, copy);
      state.choices.append(label);
    }
    if (state.unavailable) setStatus(state, 'This offer is currently out of stock.');
    if (state.editor) setStatus(state, 'Test the cart using the storefront preview.');
    updateReady(state);
  }

  function pruneHeadings(section) {
    let heading = null;
    let count = 0;
    for (const element of section.querySelector('.ibs__grid').children) {
      if (element.classList.contains('ibs__group')) {
        if (heading) heading.hidden = count === 0;
        heading = element; count = 0;
      } else if (!element.hidden) count++;
    }
    if (heading) heading.hidden = count === 0;
  }

  async function addOffer(state) {
    if (state.busy || state.button.disabled || state.editor) return;
    if (Date.now() >= expiry(state.data.expires)) { state.element.hidden = true; pruneHeadings(state.section); return; }
    const claim = uid();
    const label = state.button.textContent;
    state.busy = true;
    state.button.disabled = true;
    state.button.setAttribute('aria-busy', 'true');
    state.button.textContent = 'ADDING…';
    state.choices.querySelectorAll('select,input').forEach(element => { element.disabled = true; });
    setStatus(state, 'Adding your offer…');
    let attempted = false;
    try {
      const items = makeItems(state, claim);
      attempted = true;
      const response = await request('cart/add.js', { items });
      const cart = await request('cart.js');
      if (!checkCart(state, cart, claim, items)) throw new Error('The offer discount could not be confirmed. The offer has been removed from your cart.');
      setStatus(state, 'Added to your cart.');
      state.button.textContent = 'ADDED ✓';
      notifyCart(state.section, response, cart, state.button);
    } catch (error) {
      let removed = true;
      if (attempted) try { await removeClaim(claim); } catch (_) { removed = false; }
      state.button.textContent = label;
      setStatus(state, removed ? error.message : 'Please check your cart before trying again. The offer could not be verified.', true);
      if (!removed) {
        const link = document.createElement('a');
        link.href = `${root()}cart`;
        link.className = 'ibs__cart-link';
        link.textContent = ' View cart';
        state.status.append(link);
      }
    } finally {
      state.busy = false;
      state.button.removeAttribute('aria-busy');
      state.choices.querySelectorAll('select,input').forEach(element => { element.disabled = false; });
      state.button.disabled = state.unavailable || !state.selected.every(item => item?.variant);
      if (state.button.textContent === 'ADDED ✓') setTimeout(() => { if (!state.busy) state.button.textContent = label; }, 2400);
    }
  }

  function initialise(section) {
    if (sections.has(section)) return;
    const editor = section.dataset.editor === 'true';
    const states = [];
    for (const element of section.querySelectorAll('[data-card-id]')) {
      try {
        const data = JSON.parse(element.querySelector('[data-offer-data]').textContent);
        const ends = expiry(data.expires);
        const allowedCountries = list(data.countries);
        if (!editor && ((Number.isFinite(ends) && Date.now() >= ends) || (allowedCountries.length && !allowedCountries.includes(clean(data.country))))) { element.hidden = true; continue; }
        const excluded = list(data.excludedShades);
        const pools = data.pools.map(pool => usableProducts(pool, excluded));
        if (data.kind.startsWith('bundle_')) {
          if (!pools[1].length && !data.pools[1].length) pools[1] = pools[0];
          if (!pools[2].length && !data.pools[2].length) pools[2] = pools[0];
        }
        const tiers = list(data.volumeQuantities).map(value => {
          const match = /^(\d+)\s*:\s*(\d+(?:\.\d+)?)$/.exec(value);
          return match ? { quantity: Number(match[1]), percent: Number(match[2]) } : null;
        }).filter(tier => tier && tier.quantity > 0 && tier.quantity <= 24 && tier.percent >= 0 && tier.percent <= 100).sort((a, b) => a.quantity - b.quantity);
        const quantities = [...new Set(tiers.map(tier => tier.quantity))];
        const state = { data, element, section, editor, pools, tiers, quantities: quantities.length ? quantities : [1, 2, 3], quantity: quantities[0] || 1, addonChecked: false, selected: [], busy: false, unavailable: false, button: element.querySelector('[data-add-offer]'), choices: element.querySelector('[data-choices]'), status: element.querySelector('[data-status]') };
        state.addonChecked = state.quantity >= Number(data.addonFromQuantity) && pools[1].length > 0;
        renderChoices(state);
        if (!Number.isSafeInteger(Number(data.offerId)) || Number(data.offerId) <= 0 || Number.isNaN(ends) || (data.kind === 'volume' && !tiers.length)) {
          state.unavailable = true; state.button.disabled = true;
          setStatus(state, editor ? 'Set a valid Vitals offer ID and end date.' : 'This offer is temporarily unavailable.');
        }
        state.button.addEventListener('click', () => addOffer(state));
        states.push(state);
      } catch (_) {
        element.querySelector('[data-status]').textContent = 'This offer is temporarily unavailable.';
      }
    }
    const timer = setInterval(() => {
      if (!section.isConnected) { clearInterval(timer); return; }
      if (editor) return;
      for (const state of states) if (Date.now() >= expiry(state.data.expires)) state.element.hidden = true;
      pruneHeadings(section);
    }, 30000);
    sections.set(section, { states, timer });
    pruneHeadings(section);
  }

  const init = scope => (scope || document).querySelectorAll('[data-bundle-save]').forEach(initialise);
  window.IssadaBundleSave = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-bundle-save]').forEach(section => { const state = sections.get(section); if (state) clearInterval(state.timer); sections.delete(section); });
  });
})();


  } catch(e) { console.error(e); }
})();
})();
